import SearchAppBar from "../SearchAppBar/SearchAppBar";

function Header() {
    return (
        <header>
            <SearchAppBar/>
        </header>
    );
}

export default Header